import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  resourceWrapper: {
    padding: '24px 24px 0 24px'
  },
  headerBreadcrumbs: {
    '& ol': {
      alignItems: 'flex-end'
    }
  },
  headerBreadcrumbsTitle: {
    fontSize: 18,
    lineHeight: '24px',
    fontWeight: 'bold',
    color: '#38cfc4',
    fontFamily: `'Manrope', sans-serif`,
    '&.active': {
        color: '#465869'
    }
  }
}))

export default styles